import { RefObject, useEffect } from 'react';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { useVerticalSystemContext } from './VerticalSystemContext/VerticalSystemContext';

/**
 * A hook to apply animation to tab item link arrows
 * @param linkClassName class name of link element
 * @returns rootRef from where to search the linkClassName
 */
export function useLinkArrowAnimation(rootRef: RefObject<HTMLElement>, linkClassName: string) {
  const { activeTabItem } = useVerticalSystemContext();
  const { browser } = useBreakpoints();

  function update() {
    const links = rootRef.current?.getElementsByClassName(linkClassName);
    if (!links?.length || !activeTabItem?.link) return;

    const items = Array.from(links).map(link => {
      const arrow = link.querySelector('svg');
      const text = arrow?.previousElementSibling;

      if (!text) return {};

      const rect = text.getBoundingClientRect();
      const left = rect.right - rect.left;

      return { left, link: link as HTMLElement };
    });

    const activeLeft = items.find(item => item.left)?.left || 0;

    items.forEach(item => {
      const left = activeLeft || item.left || 0;
      item.link?.style.setProperty('--x', `${left}px`);
    });
  }

  useEffect(() => {
    setTimeout(update, 160);
  }, [activeTabItem, linkClassName, browser]);
}
